import { GLOBALS } from './global.environment';

export const ENVIRONMENT = GLOBALS;

// Overwrite general settings.
ENVIRONMENT.NAME = 'TEST';
ENVIRONMENT.PRODUCTION = false;
ENVIRONMENT.API.BASE_URL = 'https://balloons-api.test.digitalemenschen.app';
